import { c as _c } from "react/compiler-runtime";
import { css } from 'styled-components';
import styled from 'styled-components';
import { EventStatus as IEventStatus } from '../../../../../typings/Event.interface';
import { AttemptStatus as IAttemptStatus } from '../../../../../typings/EventAttempt.interface';
import Badge from './base/Badge';
const status_map: Record<IEventStatus | IAttemptStatus, {
  theme_color: string;
  text?: string;
}> = {
  SUCCESSFUL: {
    theme_color: 'success',
    text: 'Successful'
  },
  FAILED: {
    theme_color: 'danger',
    text: 'Failed'
  },
  QUEUED: {
    theme_color: 'primary',
    text: 'Pending'
  },
  HOLD: {
    theme_color: 'warning',
    text: 'Paused'
  },
  SCHEDULED: {
    theme_color: 'warning',
    text: 'Delayed'
  },
  CANCELLED: {
    theme_color: 'neutral',
    text: 'Cancelled'
  }
};
const StyledStatusBadge = styled(Badge)<{
  status: IEventStatus;
}>(({
  theme,
  status
}) => css`
    gap: ${theme.spacing(1)};
    font-family:
      JetBrains Mono,
      monospace;

    &::before {
      content: '';
      height: 8px;
      width: 8px;
      border-radius: 50%;
      margin: ${theme.spacing(1)};
      background-color: ${theme.colors.on.hue_container[status_map[status].theme_color]};
    }
  `);
export const Status: React.FC<{
  status: IEventStatus | IAttemptStatus;
  response_status: number | null;
  show_response?: boolean;
}> = t0 => {
  const $ = _c(6);
  const {
    status,
    response_status,
    show_response: t1
  } = t0;
  const show_response = t1 === undefined ? true : t1;
  let text = status_map[status].text;
  if (show_response && (status === "FAILED" || status === "SUCCESSFUL")) {
    if (response_status) {
      text = String(response_status);
    }
  }
  const t2 = status_map[status];
  let t3;
  if ($[0] !== t2.theme_color) {
    t3 = {
      [t2.theme_color]: true
    };
    $[0] = t2.theme_color;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== status || $[3] !== t3 || $[4] !== text) {
    t4 = <StyledStatusBadge status={status} mono={true} {...t3} subtle={true}>{text}</StyledStatusBadge>;
    $[2] = status;
    $[3] = t3;
    $[4] = text;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};